// Explore-stats page: Age groups and distribution.
// Recreates the Handbook page — histogram of current parliamentarians by
// age band, with a supporting table (band, number, %).

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatHistogram } from './charts';

export default function AgeGroups() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('age-groups');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Age groups and distribution"
      description={`The distribution of current parliamentarians across age groups${
        charts.total ? ` (${charts.total} parliamentarians)` : ''
      } — highlighting the small number under 35 compared with the concentration in the 50s.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="age-groups-and-distribution"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Age groups and distribution</Typography>
          <StatHistogram data={charts.age_groups || []} xKey="band" yKey="count" />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
